import { configureStore, ThunkAction, Action, Middleware } from '@reduxjs/toolkit'
import userReducer from '../features/user/userSlice'
import deviceReducer from '../features/device/deviceSlice'
import settingsReducer from '../features/settings/settingsSlice'
import companiesReducer from '../features/company/companiesSlice'
import companiesFormReducer from '../features/company/companiesFormSlice'
import usersReducer from '../features/users/usersSlice'
import notificationsReducer from '../features/notifications/notificationsSlice'
import validationsReducer from '../features/validations/validationsSlice'
import deviceTypesReducer from '../features/device/deviceTypesSlice'
import processesReducer from '../features/process/processSlice'
import activitiesReducer from '../features/validations/activitiesSlice'
import myTasksReducer from '../features/tasks/myTasksSlice'
import processTestsReducer from '../features/process/processTestsSlice'
import processStepsReducer from '../features/process/processTestStepSlice'
import processStageRemarkReducer from '../features/process/processStageRemarkSlice'
import ursReducer from '../features/urs/UrsSlice'
import requirementsReducer from '../features/requirements/RequirementsDictSlice'
import ursTemplatesReducer from '../features/urstemplates/ursTemplatesSlice'
import requirementsTypesReducer from '../features/requirements/RequirementsTypesSlice'
import riskAnalysisReducer from '../features/riskAnalysis/riskAnalysisSlice'
import areasReducer from '../features/areas/areaSlice'
import ursOffersReducer from '../features/ursOffer/ursOfferSlice'
import structureReducer from '../features/device/structureSlice'
import moduleReducer, { currentModuleStorageKey, setCurrentModule } from '../features/modules/moduleSlice'
import structureRelationshipReducer from '../features/device/structureRelationshipSlice'
import requirementTest from '../features/requirements/requirementTestSlice'
import aiQuestionsReducer from '../features/ai/aiQuestionsSlice'
import suppliersReducer from '../features/suppliers/suppliersSlice'
import ursCommentsReducer from '../features/urs/URSCommentSlice'
import mailTemplatesReducer from '../features/mailing/mailTemplatesSlice'
import ursListReducer from '../features/urs/ursListSlice'
import mailMappingReducer from '../features/systemSettings/system/mailMappingsSlice'
import supplierDevicesReducer from '../features/supplierdevices/supplierDeviceSlice'
import supplierDeviceDetailsReducer from '../features/supplierdevices/supplierDeviceDetailsSlice'
import materialCardReducer from '../features/project/materialCards/materialCardSlice'
import materialCardItemReducer from '../features/project/materialCards/materialCardItemSlice'
import projectsReducer from '../features/project/projectSlice'
import externalUrsOfferReducer from '../features/externalOffer/externalOfferSlice'
import helpArticlesReducer from '../features/systemSettings/system/helpArticlesSlice'
import dialogReducer from '../features/dialogs/dialogSlice'
import businessCaseReducer from '../features/businessCase/businessCaseSlice'
import chcReducer from '../features/chc/chcSlice'
import specReducer from '../features/specs/specSlice'
import contextStructureReducer from '../features/structure/contextStructureSlice'
import importedUrsReducer from '../features/ursOffer/importedUrsSlice'
import documentReducer from '../features/documents/documentSlice'
import sysMailFootersReducer from '../features/system/mailing/sysFooters/sysMailFootersSlice'
import sysMailTemplatesReducer from '../features/system/mailing/sysTemplates/sysMailTemplatesSlice'
import projectProcessReducer from '../features/project/projectProcess/projectProcessSlice'
import ursOfferRequirementsReducer from '../features/ursOffer/ursOfferRequirementsSlice'
import attachementsReducer from '../features/documents/attachementsSlice'
import signaturesReducer from '../features/documents/signaturesSlice'
import markerReducer from '../features/ursOffer/markerSlice'
import importedDocumentReducer from '../features/documents/importedDocuments/importedDocSlice'
import ursOfferNotesReducer from '../features/ursOffer/ursOfferNotesSlice'
import importedDocDepartmentsReducer from '../features/documents/importedDocuments/importedDocDepartmentsSlice'
import importedDocHiddenPartsReducer from '../features/documents/importedDocuments/importedDocHiddenPartsSlice'
import cacheReducer from '../features/documents/cacheSlice'
import sensorsReducer from '../features/measurements/sensorsSlice'
import cleaningRoomsReducer from '../features/measurements/cleaningRoomsSlice'
import measurementHeadersReducer from '../features/measurements/measurementHeadersSlice'
import importedDocLinkReducer from '../features/documents/importedDocuments/importedDocLinksSlice'
import backgroundProcessingReducer from '../features/backgroundProcessing/backgroundProcessingSlice'
import { backgroundPollerMiddleware } from '../features/backgroundProcessing/backgroundPollerMiddleware'
import { backgroundCompletionMiddleware } from '../features/backgroundProcessing/backgroundCompletionListener'
import discussionsReducer from '../features/documents/importedDocuments/discussionsSlice'
import supportIntegrationReducer from '../features/support/supportIntegrationSlice'
import companyDocumentNumberRulesReducer from '../features/administration/companyDocumentNumberRules/companyDocumentNumberRulesSlice'
import formSectionReducer from '../features/documents/sections/formSection/formSectionSlice'
import permissionsReducer from '../features/permissions/permissionsSlice'

const currentModulePersistenceMiddleware: Middleware = () => next => action => {
  const result = next(action)

  if (setCurrentModule.match(action)) {
    localStorage.setItem(currentModuleStorageKey, action.payload.code)
  }

  return result
}

export const store = configureStore({
  reducer: {
    user: userReducer,
    permissions: permissionsReducer,
    devices: deviceReducer,
    settings: settingsReducer,
    companyDocumentNumberRules: companyDocumentNumberRulesReducer,
    companies: companiesReducer,
    companiesForm: companiesFormReducer,
    users: usersReducer,
    notifications: notificationsReducer,
    validations: validationsReducer,
    deviceTypes: deviceTypesReducer,
    processes: processesReducer,
    activities: activitiesReducer,
    myTasks: myTasksReducer,
    processTests: processTestsReducer,
    processTestSteps: processStepsReducer,
    processStageRemarks: processStageRemarkReducer,
    urs: ursReducer,
    requirements: requirementsReducer,
    requirementsTypes: requirementsTypesReducer,
    ursTemplates: ursTemplatesReducer,
    riskAnalysis: riskAnalysisReducer,
    areas: areasReducer,
    ursOffers: ursOffersReducer,
    structure: structureReducer,
    module: moduleReducer,
    structureRelationship: structureRelationshipReducer,
    requirementTest: requirementTest,
    aiquestions: aiQuestionsReducer,
    suppliers: suppliersReducer,
    ursComments: ursCommentsReducer,
    mailTemplates: mailTemplatesReducer,
    ursList: ursListReducer,
    mailMappings: mailMappingReducer,
    supplierDevices: supplierDevicesReducer,
    supplierDeviceDetails: supplierDeviceDetailsReducer,
    materialCards: materialCardReducer,
    materialCardItems: materialCardItemReducer,
    projects: projectsReducer,
    externalUrsOffers: externalUrsOfferReducer,
    helpArticles: helpArticlesReducer,
    dialog: dialogReducer,
    businessCases: businessCaseReducer,
    chc: chcReducer,
    specs: specReducer,
    contextStructure: contextStructureReducer,
    importedUrs: importedUrsReducer,
    document: documentReducer,
    sysMailFooters: sysMailFootersReducer,
    sysMailTemplates: sysMailTemplatesReducer,
    projectProcess: projectProcessReducer,
    ursOfferRequirements: ursOfferRequirementsReducer,
    attachements: attachementsReducer,
    signatures: signaturesReducer,
    marker: markerReducer,
    importedDocument: importedDocumentReducer,
    ursOfferNotes: ursOfferNotesReducer,
    importedDocDepartments: importedDocDepartmentsReducer,
    importedDocHiddenParts: importedDocHiddenPartsReducer,
    cache: cacheReducer,
    sensors: sensorsReducer,
    cleaningRooms: cleaningRoomsReducer,
    measurementHeaders: measurementHeadersReducer,
    importedDocLinks: importedDocLinkReducer,
    backgroundProcessing: backgroundProcessingReducer,
    discussions: discussionsReducer,
    supportIntegration: supportIntegrationReducer,
    formSection: formSectionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(
      currentModulePersistenceMiddleware,
      backgroundPollerMiddleware.middleware,
      backgroundCompletionMiddleware.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
